import React, { useState } from "react";
import { ReactComponent as BillBioLogo } from "../../../assets/NewLogo.svg";
import { ReactComponent as NewLogoDark } from "../../../assets/NewLogoDark.svg";
import { ReactComponent as InstaIcon } from "../../../assets/landingPages/footer/instagram.svg";
import { ReactComponent as InstaIconDark } from "../../../assets/landingPages/footer/instagramDark.svg";
import { ReactComponent as InIcon } from "../../../assets/landingPages/footer/in.svg";
import { ReactComponent as InIconDark } from "../../../assets/landingPages/footer/inDark.svg";
import { ReactComponent as TwitterIcon } from "../../../assets/landingPages/footer/twitter.svg";
import { ReactComponent as TwitterIconDark } from "../../../assets/landingPages/footer/twitterDark.svg";
import useSettings from "../../../hooks/useSettings";
import useLocales from "../../../hooks/useLocales";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import CookiesPreferenceConfirmModal from "../../../pages/landingPages/CookiesPreferenceConfirmModal";

// Footer Component
const Footer = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { themeDirection } = useSettings();
  const { translate } = useLocales();

  const { isInvitationActive = false } = useSelector(
    (state) => state?.invitationListEmails
  );
  const users = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const userToken = users?.token;

  const handleCookiePreferencesClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="flex justify-center dark:bg-dark-secondary">
        <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full  ">
          <div className="mx-5 mb-[36px] my-7 smm:mx-7 sm:mx-7 md:mx-7 lg:mx-7 xl:mx-5 2xl:mx-10">
            {" "}
            {/* mb-[70px]*/}
            <div
              className={`mb-10 flex md:mb-9 ${
                themeDirection === "rtl" ? "flex-row-reverse" : ""
              }`}
            >
              {!userToken && isInvitationActive === true ? null : (
                <Link to={"/"} className="w-[80px] md:w-[121px]">
                  {darkMode ? (
                    <NewLogoDark className=" w-[100%] md:w-[100%] h-auto" />
                  ) : (
                    <BillBioLogo className=" w-[100%] md:w-[100%] h-auto" />
                  )}
                </Link>
              )}
            </div>
            <div
              className={`flex items-end md:items-center justify-between mb-10 md:mb-[80px] ${
                themeDirection === "rtl" ? "md:flex-row-reverse" : ""
              }`}
            >
              <div
                className={`flex flex-col md:flex-row gap-3 md:gap-6 md:items-center ${
                  themeDirection === "rtl" ? "md:flex-row-reverse" : ""
                }`}
              >
                {!userToken && isInvitationActive === true ? (
                  <Link to={"/"} className="w-[80px] md:w-[121px]">
                    {darkMode ? (
                      <NewLogoDark className=" w-[100%] md:w-[100%] h-auto" />
                    ) : (
                      <BillBioLogo className=" w-[100%] md:w-[100%] h-auto" />
                    )}
                  </Link>
                ) : null}
                {!userToken && isInvitationActive === true ? null : (
                  <Link
                    to={"about"}
                    className="text-heading_color dark:text-color_v1_dark text-small1 md:text-body_copy1_b"
                  >
                    {/* About us */}
                    {translate("header.about_us")}
                  </Link>
                )}
                {!userToken && isInvitationActive === true ? null : (
                  <Link
                    to={"contact"}
                    className="text-heading_color dark:text-color_v1_dark text-small1 md:text-body_copy1_b"
                  >
                    {/* Contact us */}
                    {translate("header.contact_us")}
                  </Link>
                )}
                {!userToken && isInvitationActive === true ? null : (
                  <Link
                    to={"pricing"}
                    className="text-heading_color dark:text-color_v1_dark text-small1 md:text-body_copy1_b"
                  >
                    {/* Pricing */}
                    {translate("header.pricing")}
                  </Link>
                )}
                {!userToken && isInvitationActive === true ? null : (
                  <Link
                    to={"report-abuse"}
                    className="text-heading_color dark:text-color_v1_dark text-small1 md:text-body_copy1_b"
                  >
                    {/*Report Abuse*/}
                    {translate("header.ReportAbuse")}
                  </Link>
                )}
              </div>
              <div className="flex gap-[18px] items-center">
                <a
                  href="https://instagram.com/bil.bio"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {darkMode ? (
                    <InstaIconDark className="w-[18px] md:w-auto" />
                  ) : (
                    <InstaIcon className="w-[18px] md:w-auto" />
                  )}
                </a>
                <a
                  href="https://www.linkedin.com/company/bilbio/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {darkMode ? (
                    <InIconDark className="w-[18px] md:w-auto" />
                  ) : (
                    <InIcon className="w-[18px] md:w-auto" />
                  )}
                </a>
                <a
                  href="https://twitter.com/BilBioHQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {darkMode ? (
                    <TwitterIconDark className="w-[18px] md:w-auto" />
                  ) : (
                    <TwitterIcon className="w-[18px] md:w-auto" />
                  )}
                </a>
              </div>
            </div>
            <hr className="border-t-1 border-gray-500" />
            <div
              className={`flex flex-col md:flex-row justify-between mt-[30px] md:mt-7 ${
                themeDirection === "rtl" ? "md:flex-row-reverse" : ""
              }`}
            >
              <div className="text-heading_color dark:text-color_v2_dark text-left text-small1  md:mb-3">
                {/* Copyright © {year} bil.bio */}
                {translate("footer.copyright")}
              </div>
              <div className="text-small2_b text-dark_bg_v5 dark:text-color_v2_dark">
                <Link to={"terms-of-service"}>
                  {/* Terms & Conditions */}
                  {translate("footer.terms_conditions")}
                </Link>{" "}
                ·{" "}
                <Link to={"privacy-policy"}>
                  {/*Privacy Policy */}
                  {translate("footer.privacy_policy")}
                </Link>
              </div>
              <div className="text-small2_b text-dark_bg_v5 dark:text-color_v2_dark">
                <div
                  className="cursor-pointer"
                  onClick={handleCookiePreferencesClick}
                >
                  {/* Update cookies preferences */}
                  {translate("footer.Update_cookies_preferences")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CookiesPreferenceConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Footer;
